import { render, staticRenderFns } from "./AppraisalList.vue?vue&type=template&id=00db635a&scoped=true&"
import script from "./AppraisalList.vue?vue&type=script&lang=ts&"
export * from "./AppraisalList.vue?vue&type=script&lang=ts&"
import style0 from "./AppraisalList.vue?vue&type=style&index=0&id=00db635a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db635a",
  null
  
)

export default component.exports